module.exports = __webpack_public_path__ + "static/media/5.5f193d58.JPG";